(function (global) { // eslint-disable-line
    'use strict';

    var Flickity = require('flickity');

    var slider = document.querySelector('[banner-slider]'),
        sliderNext = document.querySelectorAll('[banner-slider-next'),
        sliderPrev = document.querySelectorAll('[banner-slider-prev');


    if ( slider ) {
        var flkty = new Flickity(slider, {
            wrapAround: true,
            autoPlay: 5000,
            pageDots: false,
            prevNextButtons: true,
            adaptiveHeight: true,
            draggable: true
        });

        if (sliderNext) {
            for( var i = 0, maxNext = sliderNext.length; i < maxNext; i++) {
                sliderNext[i].addEventListener('click', function (e) {
                    e.preventDefault();
                    flkty.next();
                    flkty.pausePlayer();

                });
            }
        }

        // Click prev event
        if (sliderPrev) {
            for (var x = 0, maxPrev = sliderPrev.length; x < maxPrev; x++) {
                sliderPrev[x].addEventListener('click', function (e) {
                    e.preventDefault();
                    flkty.previous();
                    flkty.pausePlayer();
                });
            }
        }
    }

})(window.groots);
